export default {
    // 查询文件树形接口
    queryConfigTree(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/queryConfigTree', params, response);
    },

    // 查询配置列表信息
    queryFileInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/queryFileInfo', params, response);
    },

    // 添加配置文件属性信息
    insertConfigFile(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/insertConfigFile', params, response);
    },

    // 更新配置文件属性信息
    updateConfigFile(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/updateConfigFile', params, response);
    },

    // 删除配置文件属性信息
    deleteProperty(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/deleteProperty', params, response);
    },

    // 检测属性是否存在
    checkPropertyExist(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/fileController/checkPropertyExist', params, response);
    }
};
